module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary center-block"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações Gerais - " + _vm._s(_vm.park.name))])]), _vm._v(" "), (_vm.quizTemplate) ? _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.quizTemplate.questions), function(q) {
    return (_vm.quiz && q.isVisible) ? _c(_vm.getQuestionComponent(q), {
      key: q.uuid,
      ref: "questions",
      refInFor: true,
      tag: "component",
      attrs: {
        "question": q,
        "answer": _vm.getQuestionAnswer(q)
      },
      on: {
        "answerUpdated": _vm.onAnswerUpdated
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Salvar\n            ")]), _vm._v(" "), _c('go-back-button')], 1)]) : _vm._e()])])]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07a2a31e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/GeneralInformations.vue
// module id = 681
// module chunks = 1